import NextLink from "next/link";
import { IconExternalLink } from "@tabler/icons-react";

import css from "./Link.module.css";

export interface ILinkProps {
  children: JSX.Element | string;
  className?: string;
  href: string;
}

const BASE_CLASS = "f-AtomLink";

export const Link = ({ children, href, ...restOfProps }: ILinkProps) => {
  const commonProps = { className: css[BASE_CLASS] };
  const isInternalLink =
    href &&
    ((href.startsWith("/") && !href.startsWith("//")) || href.startsWith("#"));

  if (isInternalLink) {
    return (
      <NextLink href={href} {...commonProps} {...restOfProps}>
        {children}
      </NextLink>
    );
  }

  return (
    <a
      href={href}
      target="_blank"
      rel="noreferrer"
      {...commonProps}
      {...restOfProps}
    >
      {children}
      <IconExternalLink width={16} height={16} />
    </a>
  );
};
